import React from 'react';

import { HStack, Icon, Text } from '@betterment/samba-react';

export const AccountHighlight: React.FC<{ text: string }> = ({ text }) => (
  <HStack css={{ gap: 'space.100', alignItems: 'start' }}>
    <div>
      <Icon name="Checkmark" size="small" color="icon" />
    </div>
    <Text variant="text50" color="text" css={{ pt: 'space.25' }} dangerouslySetInnerHTML={{ __html: text }} />
  </HStack>
);
